import React, { useState, useEffect } from 'react';
import { useScrollLock } from '../../_utils/useScrollLock';
import ReactDOM from 'react-dom';
import CloseButton from '../shared/CloseButton';
import StepDesign from '../giftcard-shop/StepDesign';
import { DESIGNS } from '../gift-cards-v2/data';
import '../giftcard-shop/GiftCardShop.css'; // for the .gcs-design* grid styles
import './Wallet.css'; // modal chrome (.wallet-modal*, .wallet-cta)

// ChooseDesignModal — pick the design for a gift card that doesn't have one yet
// (bought in salon / gifted). Reuses the shop's StepDesign gallery so the look
// matches the purchase flow. CTO: in production scope `designs` to the card's
// voucher (resolveDesignsForVoucher); here we offer the available library.
const ChooseDesignModal = ({ item, onClose, onChosen }) => {
  const available = DESIGNS.filter((d) => d.available);
  const [selected, setSelected] = useState(item.designId || (available[0] && available[0].id) || null);

  // Shared ref-counted lock: overlapping modals must not restore each
  // other's locked styles (see SalonProfilePage/ConfirmBookingModal).
  useScrollLock(true);

  const confirm = () => {
    if (!selected) return;
    onChosen && onChosen(selected);
  };

  return ReactDOM.createPortal(
    <div className="wallet-modal-overlay" onClick={onClose}>
      <div className="wallet-modal wallet-modal--tall" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Choose a design">
        <header className="wallet-modal-header">
          <h2 className="wallet-modal-title">Choose a design</h2>
          <CloseButton onClick={onClose} />
        </header>

        <div className="wallet-modal-body">
          <p className="cd-sub">Pick the look for your gift card. It only changes the artwork, not the balance.</p>
          <StepDesign
            designs={available}
            selectedDesignId={selected}
            amount={item.faceValue}
            currency={item.currency}
            salonName={item.salon.name}
            onChange={setSelected}
          />
        </div>

        <div className="wallet-modal-footer">
          <button type="button" className="wallet-cta" disabled={!selected} onClick={confirm}>
            Save design
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ChooseDesignModal;
